import { site, timeline } from "@/mocks/chigua";

const principles = [
  { icon: "ri-scales-3-line", text: "吃瓜讲证据，不靠造谣带节奏" },
  { icon: "ri-chat-smile-3-line", text: "理性围观，拒绝辱骂与人身攻击" },
  { icon: "ri-focus-3-line", text: "以公开热度与讨论度说话" },
];

export default function About() {
  return (
    <section id="about" className="relative scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-[1fr_0.9fr] lg:gap-14">
        <div>
          <p className="num-tab mb-3 text-xs tracking-[0.3em] text-primary-600">ABOUT · 赛制总览</p>
          <h2 className="font-heading text-3xl font-bold leading-snug tracking-wide text-foreground-950 md:text-4xl">
            一年一度，全民吃瓜
            <span className="mt-2 block text-primary-600">当裁判的年度盘点</span>
          </h2>
          <p className="mt-6 text-base leading-8 text-foreground-700">
            {site.desc}
          </p>
          <p className="mt-4 text-base leading-8 text-foreground-700">
            从海选提名、多赛区并行开票，到半决赛反转加时、最终瓜王之夜，我们按热度、话题生命力与讨论深度层层筛选，
            只为把这一年最有后劲的候选事件，正经地、热闹地盘给你看。
          </p>

          <ul className="mt-8 space-y-3">
            {principles.map((p) => (
              <li
                key={p.text}
                className="flex items-center gap-3 rounded-2xl bg-background-100 px-4 py-3 ring-1 ring-background-200"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className={`${p.icon} text-lg`} />
                </span>
                <span className="text-sm text-foreground-800">{p.text}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="rounded-[1.6rem] bg-background-100 p-6 ring-1 ring-background-200 md:p-8">
          <h3 className="font-heading text-xl font-bold text-foreground-950">本届赛程一览</h3>
          <p className="mt-1 text-sm text-foreground-600">从海选到瓜王之夜，全程约两个月。</p>
          <ol className="relative mt-6 space-y-0">
            {timeline.map((t, i) => (
              <li key={t.phase} className="relative flex gap-4 pb-7 last:pb-0">
                {i < timeline.length - 1 && (
                  <span className="absolute left-[17px] top-10 h-[calc(100%-2.5rem)] w-px bg-background-300" />
                )}
                <span className="relative z-10 flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-full bg-background-50 text-primary-600 ring-1 ring-background-300">
                  <i className="ri-check-line text-lg" />
                </span>
                <div className="pt-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <h4 className="font-semibold text-foreground-950">{t.phase}</h4>
                    <span className="num-tab rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] tracking-wide text-secondary-900">
                      {t.range}
                    </span>
                  </div>
                  <p className="mt-1 text-sm leading-6 text-foreground-600">{t.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}